import { render, staticRenderFns } from "./Overzicht2.vue?vue&type=template&id=76769531&"
import script from "./Overzicht2.vue?vue&type=script&lang=js&"
export * from "./Overzicht2.vue?vue&type=script&lang=js&"
import style0 from "./Overzicht2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports